import React from 'react';
import '../../CustomModule.css';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';
import { NewInput } from '../../../../../Components/PIM/common/NewInput';

export function TextInput({
  name,
  placeholder,
  label,
  charCount,
  maxCount,
  onlyRead,
  fromForm,
  duplicatingItem,
  editingInput,
  pageIndex,
  gridIndex,
  value,
  onChange,
  disable,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  fontSize,
}) {
  let style = {};
  const styleInput = fontSize?.value ? { fontSize: `${fontSize?.value}px` } : {};
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const combinedStyles = getControlStyle(otherConfiguration);
  if (styleInput) {
    style = { ...combinedStyles, ...styleInput };
  }
  return (
    <div className="position-relative h-100">
      <NewInput
        type="text"
        name={name}
        placeholder={placeholder}
        className="min-h-38"
        disabled={disable}
        readOnly={onlyRead}
        value={value}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value, label, gridIndex, pageIndex)}
        style={style}
      />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
      {charCount && <div className="text-count">0/{maxCount}</div>}
    </div>
  );
}
export default TextInput;
